import { Button } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import EditLocationIcon from '@material-ui/icons/EditLocation';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { Box } from '../../UI';
import Map from '../../UI/Map';
import TextBox from '../../UI/TextBox';

export default function AssetMap({ data }) {
	const [location, setLocation] = React.useState(data.location);
	const [accessibility, setAccessibility] = React.useState('');

	return (
		<Box mb="15px">
			<ExpansionPanel>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography variant="h6"><strong>Location</strong></Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<Box display="flex" flexDirection="column" width="100%">
						<TextBox 
							value={location}
							onChange={setLocation}
							rows={1}
							label='Location'
						/>
						<Map center={!!data ? data.coords : { lat: 51.506686, lng: -0.149912 }} id={!!data && data.id} />
						<TextBox 
							value={accessibility}
							onChange={setAccessibility}
							rows={1}
							label='Accessibility'
						/>
					</Box>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</Box>
	);
}
